import * as Sentry from "@sentry/react";
import type { Router } from "@tanstack/react-router";

/**
 * Initialize Sentry for Vite + TanStack Router
 * Call this function early in your app's initialization
 */
export function initSentry(router?: Router<any, any, any>) {
  // Build integrations array
  const integrations = [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.browserProfilingIntegration(),
    Sentry.feedbackIntegration({
      autoInject: false,
      colorScheme: "light",
    }),
  ];

  // Add TanStack Router integration if router is provided
  if (router) {
    integrations.unshift(
      Sentry.tanstackRouterBrowserTracingIntegration(router),
    );
  } else {
    // Fallback to generic browser tracing if no router provided
    integrations.unshift(Sentry.browserTracingIntegration());
  }

  Sentry.init({
    dsn: "https://27019cc69fa27e964c5c5d0a761b6a64@o4506898479513600.ingest.us.sentry.io/4507464572010496",

    tracesSampler: (samplingContext) => {
      if (samplingContext.attributes?.["sentry.op"] === "graphql.operation") {
        return 0.8;
      }
      return 0.1;
    },

    debug: false,
    replaysOnErrorSampleRate: 0,
    replaysSessionSampleRate: 0,

    enabled: import.meta.env.PROD,

    sendClientReports: true,

    integrations,

    profilesSampleRate: 0.2,
    environment: import.meta.env.MODE,

    beforeSendTransaction(event) {
      if (import.meta.env.DEV) {
        console.log(
          "[Sentry] Attempting to send transaction:",
          event.transaction,
          event.request?.url,
        );
      }
      return event;
    },
  });
}

// Export Sentry for use in other parts of the app
export { Sentry };
